<template>
    <div class="CourseDetails_box main-container">
        <div class="w">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/pcViews/personal' }"
                    >个人中心</el-breadcrumb-item
                >
                <el-breadcrumb-item class="item_now"
                    >{{breadcrumb}}</el-breadcrumb-item
                >
            </el-breadcrumb>
            <div class="personal_box bgWhite">
                <div class="tablist_box">
                    <div class="personal_news">
                        <div class="avatarBox pointer" @mouseleave="changeImg = false" @mouseover="changeImg = true">
                            <img
                                :src="headImg"
                                alt="用户头像"
                                class="userImg"
                            />
                            <el-upload
                                class="avatar-uploader"
                                v-if="changeImg"
                                accept="image/png,image/jpg,image/jpeg"
                                action="#"
                                :http-request="changHeadImg"
                                :show-file-list="false"
                            >
                            <p class="changeImg">修改头像</p>
                            </el-upload>
                        </div>
                        <p>ID:{{userName}}</p>
                    </div>
                    <!-- 二级菜单组件 -->
                    <personal-tab-bar>
                        <personal-tab-item path="/pcViews/personal/information">
                            <img src="~assets/images/personal/perImg1.png" slot="item-img" alt="">
                            <p slot="item-name">我的信息</p>
                        </personal-tab-item>
                        <personal-tab-item path="/pcViews/personal/order">
                            <img src="~assets/images/personal/perImg2.png" slot="item-img" alt="">
                            <p slot="item-name">我的订单</p>
                        </personal-tab-item>
                        <personal-tab-item path="/pcViews/personal/course">
                            <img src="~assets/images/personal/perImg7.png" slot="item-img" alt="">
                            <p slot="item-name">培训班</p>
                        </personal-tab-item>
                        <personal-tab-item path="/pcViews/personal/study">
                            <img src="~assets/images/personal/perImg3.png" slot="item-img" alt="">
                            <p slot="item-name">学习进度</p>
                        </personal-tab-item>
                        <personal-tab-item path="/pcViews/personal/photo">
                            <img src="~assets/images/personal/perImg4.png" slot="item-img" alt="">
                            <p slot="item-name">证件照</p>
                        </personal-tab-item>
                        <personal-tab-item path="/pcViews/personal/certificate">
                            <img src="~assets/images/personal/perImg5.png" slot="item-img" alt="">
                            <p slot="item-name">岗位证书</p>
                        </personal-tab-item>
                        <personal-tab-item path="/pcViews/personal/password">
                            <img src="~assets/images/personal/perImg6.png" slot="item-img" alt="">
                            <p slot="item-name">修改密码</p>
                        </personal-tab-item>
                    </personal-tab-bar>
                </div>
                <div class="personal_content_box">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PersonalTabBar from "@/components/common/personalTabBar/PersonalTabBar";
import PersonalTabItem from "@/components/common/personalTabBar/PersonalTabItem";
import VueEvent from '@/VueEvent.js'
import { PcCookie, Key } from "@/utils/cookie";
import { editImg } from "api/personal"
export default {
    components: { PersonalTabBar, PersonalTabItem },
    data() {
        return {
            headImg:
                PcCookie.get(Key.headImgKey) != undefined
                    ? PcCookie.get(Key.headImgKey)
                    : require("@/assets/images/personal/defaultHeadImg.png"),
            userName: PcCookie.get(Key.userInfoKey),
            breadcrumb:'我的信息',
            changeImg:false,
        };
    },
    methods:{
        //更新用户头像
        changHeadImg(data) {
            let that = this
            let rd = new FileReader()
            let file = data.file
            rd.readAsDataURL(file)
            rd.onloadend = function () {
                const sessionId = PcCookie.get(Key.jsessIdKey);
                editImg(sessionId,this.result).then(res => {
                    const { success, msg, body } = res
                    if(success){
                        PcCookie.set(Key.headImgKey,body.data.photo);
                        VueEvent.$emit('changeHeadImg')
                        that.$message({
                            type: 'success',
                            message: msg
                        })
                    }else{
                        that.$message({
                            type: 'warning',
                            message: msg
                        })
                    }
                })
            }
        },
    },
    watch:{
        $route(to){
            const path = to.path;
            if(path == '/pcViews/personal/information'){
                this.breadcrumb = '我的信息';
            }else if(path == '/pcViews/personal/order'){
                this.breadcrumb = '我的订单';
            }else if(path == '/pcViews/personal/study'){
                this.breadcrumb = '学习进度';
            }else if(path == '/pcViews/personal/photo'){
                this.breadcrumb = '证件照';
            }else if(path == '/pcViews/personal/certificate'){
                this.breadcrumb = '我的证书';
            }else if(path == '/pcViews/personal/password'){
                this.breadcrumb = '修改密码';
            }
        }
    }
};
</script>
<style scoped lang="less">
.personal_news p {
    font-size: 16px;
    color: #3b3b3b;
}
.userImg {
    width: 100px;
    height: 100px;
    border-radius: 50%;
}
.avatarBox {
    margin: 16px auto;
    width: 100px;
    height: 100px;
    border: solid 1px #ccc;
    border-radius: 50%;
    position: relative;
    .changeImg {
        height: 100px;
        width: 100px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9;
        border-radius: 50%;
        font-size: 12px;
        color: #fff;
        line-height: 100px;
        text-align: center;
        background: rgba(0, 0, 0, 0.6);
    }
}
.personal_news {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 190px;
}
.personal_content_box {
    padding: 0 20px;
    flex: 1;
}
.tablist_box {
    width: 260px;
    height: 100%;
    background: #ececec;
}
.personal_box {
    margin-top: 36px;
    height: 746px;
    box-shadow: #d9d9d9 0px 0px 10px 4px;
    display: flex;
    flex-direction: row;
}
</style>
